export function getView(appConnection, connections, automations) {
  let missingAutomations = automations?.every(item => item.is_created === false)
  if (!missingAutomations) return false
  if (!appConnection) return true

  return (
    Array.isArray(connections) &&
    connections.filter(
      connection =>
        connection.status === 'active' &&
        connection.current_location_resource?.status === 'enabled'
    ).length > 0
  )
}
